import Action from 'redux/helpers/createAction'
const name = 'account'

export const getAccountData = Action(name + '/GET_ACCOUNT_DATA')
export const getAccountDataSuccess = Action(name + '/GET_ACCOUNT_DATA_SUCCESS', data => ({
  data: data.data.attributes
}))
export const getAccountDataFailure = Action(name + '/GET_ACCOUNT_DATA_FAILURE', error => ({
  error
}))
